<template>
  <v-card style='border: none' :width="$isTablet ? (windowInnerWidth * 0.6) : (windowInnerWidth * 0.95 - 20)">
    <div style="background: #EDE4FF;" class="pa-4 pb-8">
      <div class="d-flex flex-column align-center justify-center">
        <img style="width: 50px;" :src="require(`@/assets/images/icon-cancel.png`)" class="mt-n8">
        <span
          style='color: #8C58C9; font-size: 22px; font-weight: 700'>{{ headerTitle }}</span>
      </div>
      <div class="prompt mt-2 mb-10" style='color: #707070'>
        {{ language === 'chinese' ? '您已取消预订' : 'You have cancelled your reservation' }}
      </div>
    </div>
    <div style="background: #F8F5FD;" class="pa-4 mt-n8">
      <div class="d-flex flex-column justify-end rounded-xl pa-4 mt-n10" style="background: white">
        <div class="d-flex">
          <v-icon color='#A75CFF' class="ml-n1 mr-2">{{ icons.mdiMapMarkerRadiusOutline }}</v-icon>
          <div v-if="language === 'chinese'" class='d-flex align-center font-weight-bold' style="color: #333333">
            {{ item.cityName }}{{ item.cityName === '大连' ? '' : item.buildName
            }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}
          </div>
          <div v-else class='d-flex align-center font-weight-bold' style="color: #333333">
            {{ item.cityValue }}{{ item.cityName === '大连' ? '' : item.buildingValue
            }}{{ item.roomName === 'King Landing' ? 'King\'s Landing' : item.roomName }}
          </div>
        </div>
        <div v-if='item.code === 200' class="d-flex mt-6">
          <img style="width: 9px;" class="py-1" :src="require(`@/assets/images/icon-time.png`)">
          <div class="ml-2 d-flex flex-column justify-space-between">
            <div>{{ language === 'chinese' ? '开始时间' : 'Start' }}：<v-chip small class="mr-2">{{ getDateFromDate(item.start) }}</v-chip> <v-chip small>({{ calculateWeekday(item.start) }})</v-chip></div>
            <div>{{ language === 'chinese' ? '结束时间' : 'End' }}：<v-chip small class="mr-2">{{ getDateFromDate(item.end) }}</v-chip><v-chip small>({{ calculateWeekday(item.end) }})</v-chip></div>
          </div>
        </div>
        <div v-else>
          <div class='mt-3' style='color: #000000; font-size: 16px'>
            {{ language === 'chinese' ? item.errorMsg : 'No record of your reservation was found.' }}
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mdiAccountMultipleOutline, mdiMapMarkerRadiusOutline } from '@mdi/js'
import moment from 'moment'
import { getChineseWeekday } from '@/modules/chat/util/ChatBotUtil.js'

export default {
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  computed: {
    headerTitle() {
      if (this.item.code === 200) {
        return this.language === 'chinese' ? '取消成功' : 'Cancel successfully'
      } else {
        return this.language === 'chinese' ? '取消失败' : 'Cancel failed'
      }
    },
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {
      icons: {
        mdiMapMarkerRadiusOutline,
        mdiAccountMultipleOutline,
      },
    }
  },
  methods: {
    getTimeFromDate(dateString) {
      return moment(dateString).format('HH:mm')
    },
    getDateFromDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD HH:mm')
    },
    calculateWeekday(inputDate) {
      if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
        const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
        return this.language === 'chinese' ? getChineseWeekday(weekDay) : weekDay
      } else {
        return null
      }
    },
  },
}
</script>
<style scoped>
.image-grid {
  margin-top: 10px;
  margin-left: -5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20px, 1fr));
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;
}

/* 移动端样式 */
@media (max-width: 767px) {
  .prompt {
    font-size: 14px;
  }
  .place-detail {
    font-size: 13px;
  }
  .circle {
    margin-right: 4px;
    width: 12px;
    height: 12px;
    background: #a100ff;
    border-radius: 50%; /* 关键属性 */
  }
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .prompt {
    font-size: 16px;
  }
  .place-detail {
    font-size: 15px;
  }
  .circle {
    margin-right: 8px;
    width: 12px;
    height: 12px;
    background: #a100ff;
    border-radius: 50%; /* 关键属性 */
  }
}
</style>
